"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptVCCToSBody = exports.GetVCCToSResponse = void 0;
const typebox_1 = require("@sinclair/typebox");
/**
 * VCC Terms of Use transports.
 *
 * GET /invoice/vendor-onboarding/vcc/tos          → GetVCCToSResponse
 * POST /invoice/vendor-onboarding/vcc/tos-acceptance → AcceptVCCToSBody / GetVCCToSResponse
 *
 * `accepted` is true only when the vendor has accepted the CURRENT version.
 * The accepted* fields reflect the vendor's most recent acceptance (any version).
 */
exports.GetVCCToSResponse = typebox_1.Type.Object({
    version: typebox_1.Type.Integer(),
    text: typebox_1.Type.String(),
    accepted: typebox_1.Type.Boolean(),
    acceptedAt: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    acceptedByEmail: typebox_1.Type.Optional(typebox_1.Type.String()),
    acceptedVersion: typebox_1.Type.Optional(typebox_1.Type.Integer()),
});
exports.AcceptVCCToSBody = typebox_1.Type.Object({
    version: typebox_1.Type.Integer(),
});
//# sourceMappingURL=vcc-tos-transport.js.map